const WORKSPACE_COLORS = [
  'bg-violet-600',
  'bg-ocean-600',
  'bg-amber-600',
  'bg-emerald-600',
  'bg-rose-600',
] as const

export function getWorkspaceColor(id: string): string {
  let hash = 0
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) >>> 0
  }
  return WORKSPACE_COLORS[hash % WORKSPACE_COLORS.length]
}
